import React, { useState } from 'react';

export default function SaveDraftModal({ isOpen, onClose, onSave, defaultTitle }) {
  const [title, setTitle] = useState(defaultTitle || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(title);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">Save Your Card</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="cardTitle" className="block text-sm font-medium text-gray-700 mb-2">
              Card Title
            </label>
            <input
              type="text"
              id="cardTitle"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Card for..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoFocus
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:text-gray-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Save Draft
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 